<template>
  <div>
    <v-row v-if="result != null" no-gutters style="padding: 0">
      <v-col v-if="wWidth > 992" cols="12" style="padding: 0">
        <v-container
          id="testhtml"
          ref="testHtml"
          style="
            background: white;
            border-radius: 5px;
            position: relative;
            width: 100%;
          "
          v-if="result != null"
        >
          <v-card flat>
            <div style="height: 20px; position: relative">
              <v-btn
                :loading="loading"
                :disabled="loading"
                @click="close"
                x-small
                outlined
                class="black--text font-weight-bold"
                style="
                  font-size: 10px;
                  position: absolute;
                  right: -115px;
                  top: -5px;
                "
              >
                <v-icon x-small>mdi-chevron-left</v-icon>
                Kembali
              </v-btn>
            </div>
            <div
              style="
                z-index: 2;
                position: sticky;
                top: 0;
                background: white;
                border-bottom: 1px solid black;
                margin-bottom: 10px;
                display: flex;
                justify-content: space-between;
              "
            >
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  margin-left: 10px;
                "
              >
                <v-toolbar-title class="overline">
                  <p style="font-size: 20px; margin: 0; font-weight: bold">
                    Detail Pemindahan Aset
                    <v-tooltip bottom color="grey">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          x-small
                          text
                          icon
                          color="grey darken-2"
                          style="position: relative; top: -3px"
                          @click="getDetailData()"
                        >
                          <v-icon small>mdi-refresh</v-icon>
                        </v-btn>
                      </template>
                      <span>refresh page</span>
                    </v-tooltip>
                  </p>
                </v-toolbar-title>
              </div>
              <div class="d-flex">
                <div>
                  <div v-if="result.status == 1 && isAllow">
                    <v-btn
                      @click="approveMovement"
                      small
                      elevation="1"
                      outlined
                      color="green"
                      class="white--text font-weight-bold ma-2"
                      style="font-size: 12px"
                      :loading="loading"
                    >
                      Approve
                    </v-btn>
                    <v-btn
                      @click="rejectMovement"
                      :loading="loading"
                      small
                      elevation="1"
                      outlined
                      color="red"
                      class="red--text font-weight-bold ma-2"
                      style="font-size: 12px"
                    >
                      Reject
                    </v-btn>
                  </div>
                </div>
                <div
                  v-if="
                    getUserProfile.employee.company.plant_id ==
                      result.source_company_id ||
                    getUserProfile.level.find(({ id }) => id == 1) != undefined
                  "
                >
                  <div v-if="result.status == -2">
                    <v-btn
                      @click="setDraft"
                      small
                      elevation="1"
                      outlined
                      color="primary"
                      class="white--text font-weight-bold ma-2"
                      style="font-size: 12px"
                      :loading="loading"
                    >
                      Set Draft
                    </v-btn>
                    <!-- </div> -->
                  </div>
                </div>
                <div
                  v-if="
                    result.status == -1 ||
                    result.status == 0 ||
                    result.status == 1 ||
                    result.status == 2 ||
                    result.status == 3
                  "
                >
                  <div
                    class="d-flex"
                    v-if="
                      getUserProfile.level.find(
                        ({ id }) => id === '1' || id === '29'
                      ) != undefined
                    "
                  >
                    <div v-if="result.status == 0">
                      <v-btn
                        v-if="!isEdit"
                        @click="editHeader"
                        small
                        elevation="1"
                        outlined
                        color="blue"
                        class="white--text font-weight-bold ma-2"
                        style="font-size: 12px"
                        :loading="loading"
                      >
                        Edit
                      </v-btn>
                      <v-btn
                        v-if="!isEdit"
                        @click="submitMovement"
                        small
                        elevation="1"
                        outlined
                        color="green"
                        class="white--text font-weight-bold ma-2"
                        style="font-size: 12px"
                        :loading="loading"
                        type="button"
                      >
                        Submit
                      </v-btn>
                      <v-btn
                        v-if="isEdit"
                        @click="saveEditHeader"
                        small
                        elevation="1"
                        outlined
                        color="blue"
                        class="white--text font-weight-bold ma-2"
                        style="font-size: 12px"
                        :loading="loading"
                        type="button"
                      >
                        Simpan
                      </v-btn>
                      <v-btn
                        v-if="isEdit"
                        @click="cancelEditHeader"
                        small
                        elevation="1"
                        outlined
                        color="red"
                        class="white--text font-weight-bold ma-2"
                        style="font-size: 12px"
                        :loading="loading"
                      >
                        Batal Edit
                      </v-btn>
                      <!-- </div> -->
                    </div>

                    <div v-if="result.status == 2">
                      <div
                        v-if="
                          getUserProfile.employee.company.plant_id ==
                          result.destination_company_id
                        "
                      >
                        <v-btn
                          @click="openReceiveDialog"
                          small
                          elevation="0"
                          color="indigo"
                          class="white--text font-weight-bold ma-2"
                          style="font-size: 12px"
                          :loading="loading"
                        >
                          Terima
                        </v-btn>
                      </div>
                    </div>
                    <v-dialog v-model="dialog2" persistent width="760">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-if="
                            (result.status == -1 ||
                              result.status == 0 ||
                              result.status == 1) &&
                            getUserProfile.employee.company.plant_id ==
                              result.source_company_id &&
                            !isEdit
                          "
                          v-bind="attrs"
                          v-on="on"
                          small
                          outlined
                          elevation="1"
                          color="red"
                          class="red--text font-weight-bold ma-2"
                          style="font-size: 12px"
                          :loading="loading"
                        >
                          Batalkan
                        </v-btn>
                        <v-btn
                          v-if="
                            ((result.status == 2 || result.status == 3) &&
                              getUserProfile.employee.company.plant_id ==
                                result.destination_company_id) ||
                            getUserProfile.level.find(({ id }) => id == 1) !==
                              undefined
                          "
                          v-bind="attrs"
                          v-on="on"
                          small
                          elevation="1"
                          outlined
                          color="red"
                          class="white--text font-weight-bold ma-2"
                          style="font-size: 12px"
                          :loading="loading"
                        >
                          Batalkan
                        </v-btn>
                      </template>

                      <v-card style="padding: 20px" class="text-center">
                        <v-row>
                          <v-col cols="12" class="text-h5 font-weight-bold">
                            BERIKAN ALASAN !
                          </v-col>
                          <v-col cols="12">
                            <v-textarea
                              v-model="reason"
                              auto-grow
                              outlined
                              clearable
                            />
                          </v-col>
                          <v-col cols="12">
                            <v-btn
                              @click="cancelRequest"
                              rounded
                              elevation="1"
                              outlined
                              color="red"
                              class="red--text font-weight-bold ma-2"
                              style="font-size: 12px"
                              :loading="loading"
                            >
                              Batalkan
                            </v-btn>
                            <v-btn
                              @click="dialog2 = false"
                              rounded
                              elevation="1"
                              outlined
                              color="indigo"
                              class="indigo--text font-weight-bold ma-2"
                              style="font-size: 12px"
                            >
                              Tutup
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-dialog>
                  </div>

                  <!-- show only on admin or security -->
                  <div
                    v-if="
                      (result.status == 2 &&
                        getUserProfile.employee.level.id == 26) ||
                      this.getUserProfile.employee.level.name.toLowerCase() ==
                        'security'
                    "
                  >
                    <v-btn
                      @click="openVerifyDialog"
                      small
                      elevation="0"
                      color="indigo"
                      class="white--text font-weight-bold ma-2"
                      style="font-size: 12px"
                      :loading="loading"
                    >
                      Verifikasi
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
          </v-card>
          <v-row
            no-gutters
            v-if="result != null"
            style="position: relative; top: -13px"
          >
            <v-col cols="4">
              <p style="font-size: 12px">
                Tgl. Buat: {{ convertDate(result.createdAt) }} |
                {{ result.created_by_name }}
              </p>
            </v-col>
            <v-col cols="8">
              <div class="d-flex justify-end">
                <p
                  :style="`background-color: ${statusColor(result.status)};
                  color: white;
                  font-weight: bold;
                  margin: 5px 0 0 0;
                  padding: 0 10px;
                  border: 1px solid rgba(0, 0, 0, 0.6);
                  width: 180px;
                  text-align: center;`"
                >
                  {{ movementStatus(result.status) }}
                </p>
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col md="3" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    No. Pemindahan
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    :value="result.doc_no"
                    dense
                    readonly
                    style="margin: 0"
                  />
                </v-col>
              </div>
            </v-col>
            <v-col md="3" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Tgl. Pemindahan
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    v-if="!isEdit"
                    :value="result.schedule_from"
                    :clearable="isEdit"
                    dense
                    readonly
                    style="margin: 0"
                  />
                  <v-text-field
                    v-else
                    v-model="result.schedule_from"
                    :clearable="isEdit"
                    :outlined="isEdit"
                    dense
                    :readonly="!isEdit"
                    type="date"
                    name="date"
                    step="1"
                    style="margin: 0"
                  />
                </v-col>
              </div>
            </v-col>
            <v-col md="3" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Tgl. Pengembalian
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    v-if="!isEdit"
                    :value="result.schedule_to"
                    :clearable="isEdit"
                    dense
                    readonly
                    style="margin: 0"
                  />
                  <v-text-field
                    v-else
                    v-model="result.schedule_to"
                    clearable
                    :outlined="isEdit"
                    dense
                    :readonly="!isEdit"
                    type="date"
                    name="date"
                    step="1"
                    style="margin: 0"
                  />
                </v-col>
              </div>
            </v-col>
            <v-col md="3" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Destinasi
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    v-if="!isEdit"
                    :value="result.destination_company_name"
                    dense
                    readonly
                    style="margin: 0"
                  />

                  <v-autocomplete
                    v-else
                    v-model="result.destination"
                    :items="getDropdownCompany"
                    item-text="name"
                    item-value="id"
                    return-object
                    outlined
                    dense
                    style="margin: 0"
                  ></v-autocomplete>
                </v-col>
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col md="3" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    PIC
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    :value="result.created_by_name"
                    dense
                    readonly
                    style="margin: 0"
                  />
                </v-col>
              </div>
            </v-col>
            <v-col md="3" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Plant
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    :value="result.source_company_name"
                    dense
                    readonly
                    style="margin: 0"
                  />
                </v-col>
              </div>
            </v-col>
            <v-col md="3" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Department
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    :value="result.source_department_name"
                    dense
                    readonly
                    style="margin: 0"
                  />
                </v-col>
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <!-- kurir ditugaskan -->
            <v-col md="3" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Nama Driver
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    :value="result.driver_name"
                    :clearable="isEdit"
                    dense
                    readonly
                    style="margin: 0"
                  />
                </v-col>
              </div>
            </v-col>
            <v-col md="3" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Plat Nomor
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    :value="result.license_plate"
                    :clearable="isEdit"
                    dense
                    readonly
                    style="margin: 0"
                  />
                </v-col>
              </div>
            </v-col>
            <v-col md="3" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Tgl/Jam barang keluar
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    :value="formatDateTime(result.out_date_time)"
                    :clearable="isEdit"
                    dense
                    readonly
                    style="margin: 0"
                  />
                </v-col>
              </div>
            </v-col>
            <v-col md="3" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Di verifikasi oleh
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    :value="result.verified_out_name"
                    :clearable="isEdit"
                    dense
                    readonly
                    style="margin: 0"
                  />
                </v-col>
              </div>
            </v-col>
            <v-col md="12" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Tujuan Pemindahan
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-textarea
                    v-model="result.description"
                    dense
                    auto-grow
                    :outlined="isEdit"
                    :readonly="!isEdit"
                    rows="2"
                  />
                </v-col>
              </div>
            </v-col>

            <v-col v-if="result.status == -2" md="12" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Alasan pembatalan
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-textarea
                    :value="result.confirm_note || '-'"
                    dense
                    readonly
                    style="margin: 0"
                  />
                </v-col>
              </div>
            </v-col>
          </v-row>

          <v-row style="padding: 15px">
            <v-col cols="12">
              <v-row no-gutters dense>
                <v-col cols="4" md="2" v-if="result.status == 0">
                  <v-btn
                    elevation="2"
                    small
                    @click="addItem"
                    rounded
                    outlined
                    color="indigo"
                    class="indigo--text font-weight-bold ma-2"
                    style="font-size: 12px"
                  >
                    add item</v-btn
                  >
                </v-col>
                <v-col cols="4" md="2" style="margin-left: auto">
                  <v-btn
                    elevation="0"
                    color="transparent"
                    small
                    outlined
                    style="margin-right: 10px"
                    :loading="loading"
                    @click="downloadDokumen"
                  >
                    <v-icon color="primary" small style="margin-right: 5px"
                      >mdi-file-outline</v-icon
                    >
                    <a href="#" style="font-weight: bold">File Pendukung</a>
                  </v-btn>
                </v-col>
                <v-col
                  cols="4"
                  md="2"
                  v-if="result.status == 2 || result.status == 3"
                >
                  <v-btn
                    elevation="0"
                    color="transparent"
                    small
                    outlined
                    style="margin-right: 10px"
                    :loading="loading"
                    @click="generatePdfDokumen"
                  >
                    <v-icon color="primary" small style="margin-right: 5px"
                      >mdi-printer
                    </v-icon>
                    <a href="#" style="font-weight: bold">Print Dokumen</a>
                  </v-btn>
                </v-col>
                <v-col
                  cols="4"
                  md="2"
                  v-if="result.status == 2 || result.status == 3"
                >
                  <v-btn
                    elevation="0"
                    color="transparent"
                    small
                    outlined
                    style="margin-right: 10px"
                    :loading="loading"
                    @click="generateBADokumen"
                  >
                    <v-icon color="primary" small style="margin-right: 5px"
                      >mdi-printer
                    </v-icon>
                    <a href="#" style="font-weight: bold">Print BA</a>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col md="12" style="padding: 0 10px">
              <v-data-table
                height="30vh"
                mobile-breakpoint="0"
                fixed-header
                :items="result ? result.item : []"
                :headers="headers"
                @click:row="rowClick"
                class="elevation-1 mx-auto"
                style="
                  cursor: pointer;
                  width: 100%;
                  margin-bottom: 10px;
                  border: 1px solid #e0e0e0;
                "
                :items-per-page="10"
                hide-default-footer
              >
                <template v-slot:[`item.file`]="{ item }">
                  <div style="font-size: 12px; width: 40px; padding: 0">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ attrs, on }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          color="blue darken-2"
                          style="margin: 0"
                          small
                          @click="openItemImage(item)"
                          :disabled="item.file.length == 0"
                        >
                          mdi-image
                        </v-icon>
                      </template>
                      <span>Lihat Foto</span>
                    </v-tooltip>
                  </div>
                </template>
                <template v-slot:[`header.action`]>
                  <span>
                    Aksi
                    <v-tooltip bottom v-if="result.status == 0">
                      <template v-slot:activator="{ attrs, on }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          color="red lighten-2"
                          style="margin: 0"
                          x-small
                          @click="deleteAllItem"
                          :disabled="result != null && result.item.length == 0"
                        >
                          mdi-delete-circle
                        </v-icon>
                      </template>
                      <span>Delete All</span>
                    </v-tooltip>
                  </span>
                </template>
                <template v-slot:[`item.name`]="{ item }">
                  <div style="font-size: 12px; width: 160px; padding: 0">
                    <span
                      >({{
                        item.lot != null ? item.lot.asset.code : null
                      }})</span
                    >
                    {{ item.lot != null ? item.lot.asset.name : null }}
                  </div>
                </template>
                <template v-slot:[`item.lot_no`]="{ item }">
                  <div style="font-size: 12px; width: 80px; padding: 0">
                    {{ item.lot != null ? item.lot.lot_no : null }}
                  </div>
                </template>
                <template v-slot:[`item.company_name`]="{ item }">
                  <div style="font-size: 11px; width: 160px; padding: 0">
                    <span v-if="item.lot">{{ item.lot.company_name }}</span>
                  </div>
                </template>
                <template v-slot:[`item.current_location_name`]="{ item }">
                  <div style="font-size: 11px; width: 180px; padding: 0">
                    <span v-if="item.lot != null">{{
                      item.lot.current_company_name +
                      ' - ' +
                      item.lot.current_location_name
                    }}</span>
                  </div>
                </template>
                <template v-slot:[`item.qty_available`]="{ item }">
                  <div style="font-size: 12px; width: 40px; padding: 0">
                    <span v-if="item.lot">{{ item.lot.qty }}</span>
                  </div>
                </template>
                <template v-slot:[`item.qty_move`]="{ item }">
                  <div style="font-size: 12px; width: 40px; padding: 0">
                    {{ item.qty }}
                  </div>
                  <!-- <div v-else style="height: 40px; width: 90px">
                      <v-text-field
                        v-model="item.qty"
                        dense
                        outlined
                        type="number"
                        min="0"
                        max="9999"
                        :rules="[
                          (v) => v >= 0 || 'Min 0',
                          (v) => v <= 9999 || 'Max 9999'
                        ]"
                      />
                    </div> -->
                </template>
                <template v-slot:[`item.status`]="{ item }">
                  <div
                    :style="`font-size: 12px; width: 80px; padding: 0; color:${color(
                      item.status
                    )};`"
                  >
                    {{ itemStatus(item.status) }}
                  </div>
                </template>
                <template v-slot:[`item.noted`]="{ item }">
                  <div :style="`font-size: 12px; width: 120px; padding: 0;;`">
                    {{ item.note }}
                  </div>
                </template>

                <template v-slot:[`item.confirm`]="{ item }">
                  <div :style="`font-size: 11px; padding: 0;`">
                    <v-chip
                      x-small
                      style="
                        margin-right: 1px;
                        padding: 0 2px;
                        cursor: pointer;
                        border: 1px solid rgba(0, 0, 0, 0.5);
                        width: 60px;
                      "
                      outlined
                      :color="color(item.status)"
                    >
                      {{
                        item.received_by_name || item.rejected_by_name || '-'
                      }}
                      <!-- <v-tooltip bottom color="primary">
                        <template v-slot:activator="{ attrs, on }">
                          <div
                            v-if="item.note"
                            v-bind="attrs"
                            v-on="on"
                            style="
                              position: absolute;
                              top: -3px;
                              right: 2px;
                              bottom: 0;
                              background: white;
                            "
                          >
                            <v-icon small color="info"
                              >mdi-comment-alert-outline</v-icon
                            >
                          </div>
                        </template>
                        <span>{{ item.note }}</span>
                      </v-tooltip> -->
                    </v-chip>
                  </div>
                </template>
                <!-- <template v-slot:[`item.received_by_name`]="{ item }">
                    <div
                      :style="`font-size: 12px; width: 120px; padding: 0; color:${color(
                        item.status
                      )};`"
                    >
                      {{ item.received_by_name }}
                    </div>
                  </template> -->
                <!-- <template v-slot:[`item.rejected_by_name`]="{ item }">
                    <div
                      :style="`font-size: 12px; width: 120px; padding: 0; color:${color(
                        item.status
                      )};`"
                    >
                      {{ item.rejected_by_name }}
                    </div>
                  </template> -->
                <template v-slot:[`item.placed_location_name`]="{ item }">
                  <div style="padding: 0" @click.stop>
                    <div style="padding: 0; font-size: 12px; width: 80px">
                      {{ item.placed_location_name }}
                    </div>

                    <div
                      v-if="
                        getUserProfile.employee.company.plant_id ==
                        result.destination_company_id
                      "
                    >
                      <div
                        v-if="
                          getUserProfile.level.find(
                            ({ id }) => id === '1' || id === '29'
                          ) !== undefined
                        "
                      >
                        <div
                          style="height: 40px; width: 150px"
                          v-if="result.status == 2 && item.status == 0"
                        >
                          <v-autocomplete
                            v-if="item.lot != null"
                            v-model="item.lot.placed_location"
                            :items="getDropdownLocation"
                            item-text="name"
                            item-value="id"
                            return-object
                            outlined
                            dense
                            style="margin: 0"
                            clearable
                            :disabled="item.lot.status == -1"
                          ></v-autocomplete>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-slot:[`item.reject`]="{ item }">
                  <div
                    v-if="item.status == 0"
                    style="font-size: 12px; width: 80px; padding: 0"
                  >
                    <v-checkbox
                      v-if="item.lot != null"
                      v-model="item.lot.status"
                      :value="-1"
                      color="red"
                      style="margin: 0; height: 25px; padding: 0"
                      :disabled="item.lot.placed_location != null"
                    ></v-checkbox>
                  </div>
                </template>
                <template v-slot:[`item.action`]="{ item, index }">
                  <div style="font-size: 12px; width: 80px; padding: 0">
                    <v-tooltip bottom v-if="result.status == 0">
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          text
                          icon
                          x-small
                          color="red lighten-2"
                          @click.stop="deleteItem(item, index)"
                        >
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Delete</span>
                    </v-tooltip>

                    <v-tooltip
                      bottom
                      v-if="
                        result.status == 0 ||
                        result.status == 1 ||
                        result.status == 2
                      "
                    >
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          text
                          icon
                          x-small
                          color="blue darken-2"
                          @click.stop="uploadPhotoPerItem(item, index)"
                        >
                          <v-icon small>mdi-camera</v-icon>
                        </v-btn>
                      </template>
                      <span>Upload Photo</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ attrs, on }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          color="blue darken-2"
                          style="margin: 0"
                          small
                          @click="openItemImage(item)"
                          :disabled="item.file.length == 0"
                        >
                          mdi-image
                        </v-icon>
                      </template>
                      <span>Lihat Foto</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
          <hr />
          <div>
            <div
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                margin-left: 10px;
              "
            >
              <v-toolbar-title class="overline">
                <p style="font-size: 16px; margin: 0; font-weight: bold">
                  Approvment
                </p>
              </v-toolbar-title>
            </div>
            <v-row style="padding: 15px">
              <v-col md="12" style="padding: 0">
                <v-data-table
                  mobile-breakpoint="0"
                  :headers="approvalHeaders"
                  :items="matrix"
                  :loading="matrix.length == 0"
                  :items-per-page="10"
                  class="elevation-1 mx-auto"
                  style="
                    width: 99%;
                    margin-bottom: 10px;
                    border: 1px solid #e0e0e0;
                  "
                  hide-default-footer
                >
                  <template v-slot:[`item.approver_user`]="{ item }">
                    <div style="cursor: pointer" v-if="item">
                      <v-chip
                        label
                        outlined
                        small
                        style="
                          margin-right: 5px;
                          padding: 0 3px;
                          cursor: pointer;
                          border: 1px solid rgba(0, 0, 0, 0.5);
                        "
                        v-for="(item, index) in item.approver_user"
                        :key="index"
                      >
                        {{ item.user.name }}
                      </v-chip>
                    </div>
                  </template>
                  <template v-slot:[`item.approved`]="{ item }">
                    <div
                      v-for="(items, index) in item.approver_user"
                      :key="index"
                    >
                      <v-chip
                        v-if="items.status == 1"
                        label
                        outlined
                        small
                        style="
                          margin-right: 5px;
                          padding: 0 3px;
                          cursor: pointer;
                          border: 1px solid rgba(0, 0, 0, 0.5);
                        "
                      >
                        {{ items.user.name }}
                      </v-chip>
                    </div>
                  </template>
                  <template v-slot:[`item.rejected`]="{ item }">
                    <div
                      v-for="(items, index) in item.approver_user"
                      :key="index"
                    >
                      <v-chip
                        v-if="items.status == -1"
                        label
                        outlined
                        small
                        style="
                          margin-right: 5px;
                          padding: 0 3px;
                          cursor: pointer;
                          border: 1px solid rgba(0, 0, 0, 0.5);
                        "
                      >
                        {{ items.user.name }}
                      </v-chip>
                    </div>
                  </template>
                </v-data-table>
                <div style="text-align: right; padding-right: 5px">
                  <v-btn
                    v-if="
                      result.status == 1 &&
                      getUserProfile.level.find(
                        ({ id }) => id === '1' || id === '29'
                      ) != undefined
                    "
                    color="grey"
                    tile
                    dark
                    small
                    dense
                    style="font-size: 10px; width: 100px"
                    @click="fetchApproval"
                    :loading="loading"
                  >
                    <span>Fetch Matrix</span>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-col>
      <v-col v-if="wWidth < 992" cols="12" style="padding: 0">
        <v-container
          style="
            width: 100%;
            height: 92vh;
            overflow: auto;
            margin: auto;
            border-radius: 5px;
            background: rgba(255, 255, 255, 0.9);
            padding: 5px 15px 15px 15px;
          "
        >
          <v-btn
            @click="close"
            x-small
            outlined
            class="black--text font-weight-bold"
            style="
              font-size: 10px;
              position: absolute;
              right: 15px;
              top: 2px;
              z-index: 5;
            "
            :loading="loading"
          >
            <v-icon x-small>mdi-chevron-left</v-icon>
            Kembali
          </v-btn>
          <v-row
            no-gutters
            style="
              width: 100%;
              position: fixed;
              bottom: 0;
              left: 0;
              z-index: 2;
              background: white;
            "
          >
            <v-col
              cols="12"
              class="d-flex"
              style="position: relative; padding: 0 20px; text-align: center"
            >
              <h5 style="font-weight: bold; margin: auto"></h5>
            </v-col>
            <div style="width: 100%">
              <div
                v-if="result != null"
                class="d-flex justify-center align-center"
                style="width: 100%; background: white"
              >
                <div>
                  <div v-if="result.status == 1 && isAllow">
                    <v-btn
                      @click="approveMovement"
                      :loading="loading"
                      small
                      elevation="1"
                      outlined
                      color="green"
                      class="green--text font-weight-bold ma-2"
                      style="font-size: 12px"
                    >
                      Approve
                    </v-btn>
                    <v-btn
                      @click="rejectMovement"
                      :loading="loading"
                      small
                      elevation="1"
                      outlined
                      color="red"
                      class="red--text font-weight-bold ma-2"
                      style="font-size: 12px"
                    >
                      Reject
                    </v-btn>
                    <!-- </div> -->
                  </div>
                </div>
                <div
                  v-if="
                    result.status == -1 ||
                    result.status == 0 ||
                    result.status == 1 ||
                    result.status == 2 ||
                    result.status == 3
                  "
                >
                  <div
                    class="d-flex"
                    v-if="
                      getUserProfile.level.find(
                        ({ id }) => id === '1' || id === '29'
                      ) != undefined
                    "
                  >
                    <div v-if="result.status == 0">
                      <v-btn
                        v-if="!isEdit"
                        @click="editHeader"
                        small
                        elevation="1"
                        outlined
                        color="blue"
                        class="white--text font-weight-bold ma-2"
                        style="font-size: 12px"
                        :loading="loading"
                      >
                        Edit
                      </v-btn>
                      <v-btn
                        v-if="!isEdit"
                        @click="submitMovement"
                        small
                        elevation="1"
                        outlined
                        color="green"
                        class="white--text font-weight-bold ma-2"
                        style="font-size: 12px"
                        :loading="loading"
                        type="button"
                      >
                        Submit
                      </v-btn>
                      <v-btn
                        v-if="isEdit"
                        @click="saveEditHeader"
                        small
                        elevation="1"
                        outlined
                        color="blue"
                        class="white--text font-weight-bold ma-2"
                        style="font-size: 12px"
                        :loading="loading"
                        type="button"
                      >
                        Simpan
                      </v-btn>
                      <v-btn
                        v-if="isEdit"
                        @click="cancelEditHeader"
                        small
                        elevation="1"
                        outlined
                        color="red"
                        class="white--text font-weight-bold ma-2"
                        style="font-size: 12px"
                        :loading="loading"
                      >
                        Batal Edit
                      </v-btn>
                    </div>

                    <div v-if="result.status == 2">
                      <div
                        v-if="
                          getUserProfile.employee.company.plant_id ==
                          result.destination_company_id
                        "
                      >
                        <v-btn
                          v-if="result.status == 2"
                          @click="openReceiveDialog"
                          small
                          elevation="0"
                          color="indigo"
                          class="white--text font-weight-bold ma-2"
                          style="font-size: 12px"
                          :loading="loading"
                        >
                          Terima
                        </v-btn>
                      </div>
                    </div>
                    <v-dialog v-model="dialog2" persistent width="760">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-if="
                            (result.status == -1 ||
                              result.status == 0 ||
                              result.status == 1) &&
                            getUserProfile.employee.company.plant_id ==
                              result.source_company_id &&
                            !isEdit
                          "
                          v-bind="attrs"
                          v-on="on"
                          small
                          outlined
                          elevation="1"
                          color="red"
                          class="red--text font-weight-bold ma-2"
                          style="font-size: 12px"
                          :loading="loading"
                        >
                          Batalkan
                        </v-btn>
                        <v-btn
                          v-if="
                            ((result.status == 2 || result.status == 3) &&
                              getUserProfile.employee.company.plant_id ==
                                result.destination_company_id) ||
                            getUserProfile.level.find(({ id }) => id == 1) !==
                              undefined
                          "
                          v-bind="attrs"
                          v-on="on"
                          small
                          elevation="1"
                          outlined
                          color="red"
                          class="white--text font-weight-bold ma-2"
                          style="font-size: 12px"
                          :loading="loading"
                        >
                          Batalkan
                        </v-btn>
                      </template>

                      <v-card style="padding: 20px" class="text-center">
                        <v-row>
                          <v-col cols="12" class="text-h5 font-weight-bold">
                            BERIKAN ALASAN !
                          </v-col>
                          <v-col cols="12">
                            <v-textarea
                              v-model="reason"
                              auto-grow
                              outlined
                              clearable
                            />
                          </v-col>
                          <v-col cols="12">
                            <v-btn
                              @click="cancelRequest"
                              rounded
                              elevation="1"
                              outlined
                              color="red"
                              class="red--text font-weight-bold ma-2"
                              style="font-size: 12px"
                              :loading="loading"
                            >
                              Batalkan
                            </v-btn>
                            <v-btn
                              @click="dialog2 = false"
                              rounded
                              elevation="1"
                              outlined
                              color="indigo"
                              class="indigo--text font-weight-bold ma-2"
                              style="font-size: 12px"
                            >
                              Tutup
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-dialog>
                  </div>

                  <!-- show only on admin or security -->
                  <div
                    v-if="
                      (result.status == 2 &&
                        getUserProfile.employee.level.id == 26) ||
                      this.getUserProfile.employee.level.name.toLowerCase() ==
                        'security'
                    "
                  >
                    <v-btn
                      @click="openVerifyDialog"
                      elevation="0"
                      color="indigo"
                      class="white--text font-weight-bold ma-2"
                      style="font-size: 12px"
                      :loading="loading"
                    >
                      Verifikasi
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
          </v-row>
          <v-expansion-panels
            v-model="panel"
            multiple
            class="mb-1 pt-5"
            elevation="1"
          >
            <v-expansion-panel>
              <v-expansion-panel-header
                expand-icon="mdi-menu-down"
                style="font-weight: bold"
              >
                Detail Pemindahan
                <div class="d-flex justify-end">
                  <p
                    :style="`background-color: ${statusColor(result.status)};
                  color: white;
                  font-weight: bold;
                  margin: 5px 0 0 0;
                  padding: 0 10px;
                  border: 1px solid rgba(0, 0, 0, 0.6);
                  width: 180px;
                  text-align: center;`"
                  >
                    {{ movementStatus(result.status) }}
                  </p>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row
                  v-if="result != null"
                  no-gutters
                  style="padding: 0; margin-top: 10px"
                >
                  <v-col cols="12" md="6" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          No. Pemindahan
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          dense
                          :value="result.doc_no || '-'"
                          readonly
                          style="margin: 0; font-size: 12px"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Tgl. Pemindahan
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          v-if="!isEdit"
                          :value="result.schedule_from"
                          clearable
                          dense
                          readonly
                          style="margin: 0; font-size: 12px"
                        />
                        <v-text-field
                          v-else
                          v-model="result.schedule_from"
                          clearable
                          :outlined="isEdit"
                          dense
                          :readonly="!isEdit"
                          type="date"
                          name="date"
                          step="1"
                          style="margin: 0; font-size: 12px"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Tgl. Pengembalian
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          v-if="!isEdit"
                          :value="result.schedule_to"
                          clearable
                          dense
                          readonly
                          style="margin: 0; font-size: 12px"
                        />
                        <v-text-field
                          v-else
                          v-model="result.schedule_to"
                          clearable
                          :outlined="isEdit"
                          dense
                          :readonly="!isEdit"
                          type="date"
                          name="date"
                          step="1"
                          style="margin: 0; font-size: 12px"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Destinasi
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          v-if="!isEdit"
                          :value="result.destination_company_name"
                          dense
                          readonly
                          style="margin: 0; font-size: 12px"
                        />

                        <v-autocomplete
                          v-else
                          v-model="result.destination"
                          :items="getDropdownCompany"
                          item-text="name"
                          item-value="id"
                          return-object
                          outlined
                          dense
                          style="margin: 0; font-size: 12px"
                        ></v-autocomplete>
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          PIC
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          dense
                          :value="result.created_by_name || '-'"
                          readonly
                          style="margin: 0; font-size: 12px"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Plant
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          dense
                          :value="result.source_company_name || '-'"
                          readonly
                          style="margin: 0; font-size: 12px"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <!-- kurir ditugaskan -->
                  <v-col cols="12" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Nama Driver
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          :value="result.driver_name"
                          clearable
                          dense
                          readonly
                          style="margin: 0; font-size: 12px"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Plat Nomor
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          :value="result.license_plate"
                          clearable
                          dense
                          readonly
                          style="margin: 0; font-size: 12px"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Tgl/Jam barang keluar
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          :value="formatDateTime(result.out_date_time)"
                          clearable
                          dense
                          readonly
                          style="margin: 0; font-size: 12px"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Di verifikasi oleh
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          :value="result.verified_out_name"
                          clearable
                          dense
                          readonly
                          style="margin: 0; font-size: 12px"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Tujuan pemindahan
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-textarea
                          :value="result.description || '-'"
                          dense
                          auto-grow
                          rows="2"
                          outlined
                          style="margin: 0; font-size: 12px"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col
                    v-if="result.status == -2"
                    cols="12"
                    md="6"
                    style="padding: 0"
                  >
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Alasan pembatalan
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          outlined
                          dense
                          :value="result.confirm_note || '-'"
                          readonly
                          style="margin: 0; font-size: 12px"
                        />
                      </v-col>
                    </div>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header
                expand-icon="mdi-menu-down"
                style="font-weight: bold"
              >
                <div class="d-flex">
                  <v-tooltip bottom v-if="isEdit">
                    <template v-slot:activator="{ attrs, on }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        color="red lighten-2"
                        style="margin: 0"
                        x-small
                        @click="deleteAllItem"
                        :disabled="result != null && result.item.length == 0"
                      >
                        mdi-delete-circle
                      </v-icon>
                    </template>
                    <span>Delete All</span>
                  </v-tooltip>
                  Barang yang dipindahkan
                  <span
                    v-if="result"
                    style="
                      font-size: 9px;
                      font-weight: normal;
                      margin-left: 2px;
                    "
                  >
                    ({{ result.item.length }})
                  </span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div v-if="result != null && result.item.length > 0">
                  <v-row no-gutters style="padding: 0">
                    <v-col
                      v-for="(item, index) in result.item"
                      :key="index"
                      cols="12"
                      md="6"
                      style="padding: 0"
                    >
                      <v-expansion-panel>
                        <v-expansion-panel-header expand-icon="mdi-menu-down">
                          <div class="d-flex">
                            <div
                              v-if="isEdit"
                              style="font-size: 12px; width: 40px; padding: 0"
                            >
                              <v-tooltip bottom>
                                <template v-slot:activator="{ attrs, on }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    text
                                    icon
                                    x-small
                                    color="red lighten-2"
                                    @click="deleteItem(item, index)"
                                  >
                                    <v-icon small>mdi-delete</v-icon>
                                  </v-btn>
                                </template>
                                <span>Delete</span>
                              </v-tooltip>
                            </div>
                            <div
                              class="d-flex flex-column"
                              style="font-size: 12px"
                            >
                              <span>Lot. {{ item.lot.lot_no || '-' }}</span>
                              <span>
                                ({{ item.lot.asset.code || '-' }})
                                {{ item.lot.asset.name || '-' }}
                              </span>
                            </div>
                            <div
                              v-if="item.file"
                              style="position: relative; top: 7px; left: 50px"
                            >
                              <v-tooltip bottom>
                                <template v-slot:activator="{ attrs, on }">
                                  <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    color="blue darken-2"
                                    style="margin: 0"
                                    small
                                    @click.stop="openItemImage(item)"
                                    :disabled="item.file.length == 0"
                                  >
                                    mdi-image
                                  </v-icon>
                                </template>
                                <span>Lihat Foto</span>
                              </v-tooltip>
                            </div>
                          </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-card
                            elevation="2"
                            tile
                            outlined
                            style="
                              padding: 10px 10px 0 10px;
                              margin-bottom: 20px;
                            "
                          >
                            <v-row no-gutters style="padding: 15px 10px">
                              <v-col cols="12" style="padding: 5px 0">
                                <v-text-field
                                  dense
                                  :value="item.lot.lot_no || '-'"
                                  readonly
                                  label="Lot"
                                  style="margin: 0; font-size: 12px"
                                />
                              </v-col>
                              <v-col cols="12" style="padding: 5px 0">
                                <v-text-field
                                  dense
                                  :value="item.lot.asset.name || '-'"
                                  readonly
                                  label="Nama Aset"
                                  style="margin: 0; font-size: 12px"
                                />
                              </v-col>
                              <v-col cols="12" style="padding: 5px 0">
                                <v-text-field
                                  dense
                                  :value="item.lot.asset.code || '-'"
                                  readonly
                                  label="Kode"
                                  style="margin: 0; font-size: 12px"
                                />
                              </v-col>
                              <v-col cols="12" style="padding: 5px 0">
                                <v-text-field
                                  dense
                                  :value="item.lot.company_name || '-'"
                                  readonly
                                  label="Kepemilikan"
                                  style="margin: 0; font-size: 12px"
                                />
                              </v-col>
                              <v-col cols="12" style="padding: 5px 0">
                                <v-text-field
                                  dense
                                  :value="item.placed_location_name || '-'"
                                  readonly
                                  label="Lokasi asal"
                                  style="margin: 0; font-size: 12px"
                                />
                              </v-col>
                              <v-col cols="5" style="padding: 5px 0">
                                <v-text-field
                                  dense
                                  :value="item.lot.qty"
                                  readonly
                                  label="Qty tersedia"
                                  style="margin: 0; font-size: 12px"
                                />
                              </v-col>
                              <v-col cols="2"></v-col>
                              <v-col cols="5" style="padding: 5px 0">
                                <v-text-field
                                  dense
                                  :value="item.qty"
                                  readonly
                                  label="Qty transfer"
                                  style="margin: 0; font-size: 12px"
                                />
                              </v-col>
                              <!-- <v-col cols="12" style="padding: 5px 0">
                                <v-text-field
                                  dense
                                  :value="item.note"
                                  readonly
                                  label="Status"
                                  style="
                                    margin: 0;
                                    height: 40px;
                                    font-size: 12px;
                                  "
                                />
                              </v-col> -->
                              <v-col cols="5" style="padding: 5px 0">
                                <v-text-field
                                  dense
                                  :value="itemStatus(item.status) || '-'"
                                  readonly
                                  label="Status"
                                  style="
                                    margin: 0;
                                    height: 40px;
                                    font-size: 12px;
                                  "
                                />
                              </v-col>
                              <v-col cols="2"></v-col>
                              <v-col
                                v-if="result.status == 2"
                                cols="12"
                                md="6"
                                style="padding: 5px 0"
                              >
                                <div
                                  v-if="
                                    getUserProfile.employee.company.plant_id ==
                                    result.destination_company_id
                                  "
                                >
                                  <div v-if="item.status == 0">
                                    <v-autocomplete
                                      v-if="item.lot != null"
                                      v-model="item.lot.placed_location"
                                      :items="getDropdownLocation"
                                      item-text="name"
                                      item-value="id"
                                      return-object
                                      outlined
                                      dense
                                      style="
                                        margin: 0;
                                        height: 40px;
                                        font-size: 12px;
                                      "
                                      label="-Terima di gudang -"
                                      clearable
                                      :disabled="item.lot.status == -1"
                                    ></v-autocomplete>
                                  </div>
                                </div>
                              </v-col>
                              <!-- <v-col
                                v-if="result.status == 2"
                                cols="12"
                                md="6"
                                style="padding: 5px 0"
                              >
                                <div
                                  v-if="
                                    getUserProfile.employee.company.plant_id ==
                                    result.destination_company_id
                                  "
                                >
                                  <div
                                    v-if="item.status == 0"
                                    style="
                                      padding: 0;
                                      display: flex;
                                      flex-direction: row;
                                      justify-content: flex-start;
                                      align-items: center;
                                    "
                                  >
                                    <v-checkbox
                                      v-if="item.lot != null"
                                      v-model="item.lot.status"
                                      :value="-1"
                                      color="red"
                                      style="
                                        margin: 0;
                                        height: 25px;
                                        padding: 0;
                                      "
                                      :disabled="
                                        item.lot.placed_location != null
                                      "
                                    ></v-checkbox>
                                    <p
                                      style="
                                        margin-bottom: 0;
                                        margin-right: 15px;
                                        font-size: 14px;
                                      "
                                    >
                                      Tolak
                                    </p>
                                  </div>
                                </div>
                              </v-col> -->
                              <v-col
                                v-if="item.status == 1"
                                cols="5"
                                style="padding: 5px 0"
                              >
                                <v-text-field
                                  dense
                                  :value="item.received_by_name || '-'"
                                  readonly
                                  label="Diterima oleh"
                                  style="margin: 0; font-size: 12px"
                                />
                              </v-col>
                              <v-col
                                v-if="item.status == -1"
                                cols="5"
                                style="padding: 5px 0"
                              >
                                <v-text-field
                                  dense
                                  :value="item.rejected_by_name || '-'"
                                  readonly
                                  label="Ditolak oleh"
                                  style="margin: 0; font-size: 12px"
                                />
                              </v-col>
                              <v-col cols="12" class="d-flex p-1">
                                <div
                                  class="pr-1"
                                  v-if="
                                    result.status == 0 ||
                                    result.status == 1 ||
                                    result.status == 2
                                  "
                                >
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ attrs, on }">
                                      <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        small
                                        color="blue darken-2"
                                        @click="uploadPhotoPerItem(item, index)"
                                      >
                                        <v-icon small>mdi-camera</v-icon> Upload
                                        foto
                                      </v-btn>
                                    </template>
                                    <span>Upload Photo</span>
                                  </v-tooltip>
                                </div>
                                <div class="pl-1">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ attrs, on }">
                                      <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        small
                                        outlined
                                        color="blue darken-2"
                                        @click="openItemImage(item)"
                                        :disabled="item.file.length == 0"
                                      >
                                        <v-icon small>mdi-image</v-icon> Lihat
                                        foto
                                      </v-btn>
                                    </template>
                                    <span>Lihat Photo</span>
                                  </v-tooltip>
                                </div>
                              </v-col>
                            </v-row>
                          </v-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-col>
                  </v-row>
                </div>
                <div v-else class="d-flex justify-center align-center">
                  Tidak ada item
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel style="margin-bottom: 50px">
              <v-expansion-panel-header
                expand-icon="mdi-menu-down"
                style="font-weight: bold"
                >Approval
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div v-if="result != null">
                  <v-row no-gutters style="padding: 0">
                    <v-col md="12" style="padding: 0">
                      <v-data-table
                        height="30vh"
                        mobile-breakpoint="0"
                        :headers="approvalHeaders"
                        :items="matrix"
                        :loading="matrix.length == 0"
                        :items-per-page="10"
                        class="elevation-1 mx-auto"
                        style="
                          width: 99%;
                          margin-bottom: 10px;
                          border: 1px solid #e0e0e0;
                        "
                        hide-default-footer
                      >
                        <template v-slot:[`item.approver_user`]="{ item }">
                          <div style="cursor: pointer" v-if="item">
                            <v-chip
                              label
                              outlined
                              small
                              style="
                                margin-right: 5px;
                                padding: 0 3px;
                                cursor: pointer;
                                border: 1px solid rgba(0, 0, 0, 0.5);
                              "
                              v-for="(item, index) in item.approver_user"
                              :key="index"
                            >
                              {{ item.user.name }}
                            </v-chip>
                          </div>
                        </template>
                        <template v-slot:[`item.approved`]="{ item }">
                          <div
                            v-for="(items, index) in item.approver_user"
                            :key="index"
                          >
                            <v-chip
                              v-if="items.status == 1"
                              label
                              outlined
                              small
                              style="
                                margin-right: 5px;
                                padding: 0 3px;
                                cursor: pointer;
                                border: 1px solid rgba(0, 0, 0, 0.5);
                              "
                            >
                              {{ items.user.name }}
                            </v-chip>
                          </div>
                        </template>
                        <template v-slot:[`item.rejected`]="{ item }">
                          <div
                            v-for="(items, index) in item.approver_user"
                            :key="index"
                          >
                            <v-chip
                              v-if="items.status == -1"
                              label
                              outlined
                              small
                              style="
                                margin-right: 5px;
                                padding: 0 3px;
                                cursor: pointer;
                                border: 1px solid rgba(0, 0, 0, 0.5);
                              "
                            >
                              {{ items.user.name }}
                            </v-chip>
                          </div>
                        </template>
                      </v-data-table>
                      <div style="text-align: right; padding-right: 5px">
                        <v-btn
                          v-if="
                            result.status == 1 &&
                            getUserProfile.level.find(
                              ({ id }) => id === '1' || id === '29'
                            ) != undefined
                          "
                          color="grey"
                          tile
                          dark
                          small
                          dense
                          style="font-size: 10px; width: 100px"
                          @click="fetchApproval"
                          :loading="loading"
                        >
                          <span>Fetch Matrix</span>
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <div
            style="
              position: fixed;
              z-index: 2;
              bottom: 80px;
              right: 0;
              display: flex;
              flex-direction: column;
              align-items: end;
              font-size: 12px;
            "
          >
            <v-btn
              v-if="result.status == 0"
              @click="addItem"
              :loading="loading"
              small
              rounded
              style="margin-top: 10px"
              elevation="0"
              class="indigo--text font-weight-bold ma-2"
            >
              <a href="#" style="font-weight: bold">Tambah Item</a>
              <v-icon color="primary" small style="margin-left: 5px"
                >mdi-plus-box</v-icon
              >
            </v-btn>
            <v-btn
              :loading="loading"
              small
              rounded
              style="margin-top: 10px"
              elevation="0"
              class="indigo--text font-weight-bold ma-2"
              @click="downloadDokumen"
            >
              <a href="#" style="font-weight: bold">File Pendukung</a>
              <v-icon color="primary" small style="margin-left: 5px"
                >mdi-file-outline</v-icon
              >
            </v-btn>
            <v-btn
              v-if="result.status == 2 || result.status == 3"
              :loading="loading"
              small
              rounded
              style="margin-top: 10px"
              elevation="0"
              class="indigo--text font-weight-bold ma-2"
              @click="generatePdfDokumen"
            >
              <a href="#" style="font-weight: bold">Print Pdf</a>
              <v-icon color="primary" small style="margin-left: 5px"
                >mdi-printer
              </v-icon>
            </v-btn>
            <v-btn
              v-if="result.status == 2 || result.status == 3"
              :loading="loading"
              small
              rounded
              style="margin-top: 10px"
              elevation="0"
              class="indigo--text font-weight-bold ma-2"
              @click="generateBADokumen"
            >
              <a href="#" style="font-weight: bold">Print BA</a>
              <v-icon color="primary" small style="margin-left: 5px"
                >mdi-printer
              </v-icon>
            </v-btn>
          </div>
        </v-container>
      </v-col>
    </v-row>
    <div style="position: fixed; z-index: 2; bottom: 10px; right: 0">
      <Scanner
        @lotProcess="lotProcess"
        :page="'movementdetail'"
        @loadPage="getDetailData"
      />
    </div>
    <div style="height: 0; overflow: hidden">
      <lot-moving-process
        :result="lot_item"
        :movementId="movementId"
        @loadPage="getDetailData"
      />
    </div>
    <div v-if="result != null">
      <add-item @getLot="initLot" :lotHeaders="headers" />
    </div>
    <!-- DOKUMEN DIALOG -->
    <v-dialog
      v-if="result != null"
      v-model="dokumenDialog"
      width="500"
      persistent
    >
      <v-card style="position: relative">
        <v-card-title class="text-h5 grey lighten-2">
          Dokumen Pendukung
        </v-card-title>
        <v-card-text class="d-flex justify-center align-center">
          <v-col md="12" style="padding: 0; position: relative; top: 20px">
            <v-data-table
              v-if="result.file != null"
              mobile-breakpoint="0"
              fixed-header
              height="300"
              style="cursor: pointer"
              :headers="documentHeaders"
              :items="result.file"
              @click:row="readyToDownload"
              hide-default-footer
            >
              <template v-slot:[`item.subject`]="{ item }">
                <div
                  style="
                    font-size: 11px;
                    padding: 0;
                    display: flex;
                    flex-direction: row;
                  "
                >
                  {{
                    item.subject !== null
                      ? item.subject !== ''
                        ? item.subject
                        : '-'
                      : '-'
                  }}
                </div>
              </template>
              <template v-slot:[`item.description`]="{ item }">
                <div
                  style="
                    font-size: 11px;
                    padding: 0;
                    display: flex;
                    flex-direction: row;
                  "
                >
                  {{
                    item.description !== null
                      ? item.description !== ''
                        ? item.description
                        : '-'
                      : '-'
                  }}
                </div>
              </template>
              <template v-slot:[`item.type`]="{ item }">
                <div
                  style="
                    font-size: 11px;
                    padding: 0;
                    display: flex;
                    flex-direction: row;
                  "
                >
                  {{
                    item.type !== null
                      ? item.type !== ''
                        ? item.type
                        : '-'
                      : '-'
                  }}
                </div>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <div
                  style="
                    font-size: 12px;
                    padding: 0;
                    display: flex;
                    flex-direction: row;
                  "
                >
                  <v-btn
                    v-if="
                      (result.status == 0 ||
                        result.status == 1 ||
                        result.status == 2) &&
                      getUserProfile.employee.id == item.created_by
                    "
                    icon
                    x-small
                    @click.stop="
                      unlinkDokumen(
                        item.file.slice(item.file.lastIndexOf('/') + 1)
                      )
                    "
                    style="margin-right: 5px"
                  >
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-btn>
                  <v-btn icon x-small @click.stop="readyToDownload(item)">
                    <v-icon color="green">mdi-download</v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>
            <v-btn
              v-if="
                result.status == 0 || result.status == 1 || result.status == 2
              "
              elevation="0"
              style="margin-right: auto; width: 100%"
              :loading="loading"
              color="primary"
              @click="uploadDoc('upload')"
            >
              <v-icon small style="margin-right: 5px">mdi-upload</v-icon>
              <span :style="`font-weight: bold; color:white;`"
                >Tambah Dokumen</span
              >
            </v-btn>
          </v-col>
        </v-card-text>
        <!-- <v-btn icon color="black" text @click="closeDokumenDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn> -->
        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            color="error"
            text
            outlined
            @click="closeDokumenDialog"
            :loading="loading"
          >
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="
              (getUserProfile.employee.company.plant_id ==
                result.source_company_id &&
                getUserProfile.level.find(({ id }) => id == 29) !==
                  undefined) ||
              getUserProfile.level.find(({ id }) => id == 1) !== undefined
            "
            color="error"
            text
            outlined
            :loading="loading"
            @click="deleteAllFile"
          >
            Delete all File
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="fileUploadDialog" width="500" persistent>
      <v-form
        :disabled="loading"
        lazy-validation
        ref="entryFormUpload"
        @submit.prevent="submitUploadDoc"
        style="position: relative"
      >
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"> UPLOAD </v-card-title>

          <v-card-text class="d-flex justify-center align-center">
            <v-col md="12" style="padding: 0; position: relative; top: 20px">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Subject
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <div>
                    <v-text-field
                      outlined
                      v-model="file_subject"
                      dense
                      :rules="rules.subjectRules"
                    ></v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Keterangan Tambahan
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <div>
                    <v-textarea
                      v-model="uploadDescription"
                      dense
                      :auto-grow="true"
                      outlined
                      rows="1"
                    />
                  </div>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <div
                    style="padding: 10px; border: 2px dashed grey; height: 70px"
                  >
                    <v-file-input
                      ref="uploadDoc"
                      placeholder="Pilih File"
                      dense
                      append-icon="mdi-paperclip"
                      prepend-icon=""
                      @change="uploadFileDoc"
                      :rules="rules.docRules"
                    ></v-file-input>
                  </div>
                </v-col>
              </div>
            </v-col>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn
              id="closeFileUpload"
              color="error"
              text
              outlined
              type="reset"
              @click="uploadDoc('close')"
              :loading="loading"
            >
              close
            </v-btn>
            <v-spacer />
            <v-btn
              color="primary"
              text
              outlined
              type="submit"
              :loading="loading"
              :disabled="fileNameUpload === '' || file_subject === ''"
            >
              simpan file
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="verifyOutDialog" width="500" persistent>
      <v-form
        v-if="verifyForm != null"
        :disabled="loading"
        lazy-validation
        ref="verifyOutForm"
        @submit.prevent="submitVerifyOut"
        style="position: relative"
      >
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Verifikasi Barang Keluar
          </v-card-title>

          <v-card-text class="d-flex justify-center align-center">
            <v-col md="12" style="padding: 0; position: relative; top: 20px">
              <v-row no-gutters>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    v-model="verifyForm.driver_name"
                    dense
                    outlined
                    label="Nama Driver *"
                    :rules="rules.driverRules"
                    style="margin: 0"
                  />
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    v-model="verifyForm.license_plate"
                    dense
                    outlined
                    label="Plat Nomor *"
                    :rules="rules.licenseRules"
                    style="margin: 0"
                  />
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    v-model="verifyForm.out_date_time"
                    dense
                    outlined
                    label="Tanggal Keluar *"
                    type="datetime-local"
                    :rules="rules.outDateRules"
                    style="margin: 0"
                  />
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Keterangan Tambahan
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <div>
                    <v-textarea
                      v-model="uploadDescription"
                      dense
                      :auto-grow="true"
                      outlined
                      rows="1"
                    />
                  </div>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Upload *
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <div
                    style="padding: 10px; border: 2px dashed grey; height: 70px"
                  >
                    <v-file-input
                      ref="uploadDoc"
                      placeholder="Pilih File"
                      dense
                      append-icon="mdi-paperclip"
                      prepend-icon=""
                      @change="uploadFileDoc"
                      :rules="rules.photoRules"
                    ></v-file-input>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn
              id="closeVerifyDialog"
              color="error"
              text
              outlined
              type="reset"
              @click="closeVerifyDialog"
              :loading="loading"
            >
              Batal
            </v-btn>
            <v-spacer />
            <v-btn
              color="primary"
              text
              outlined
              type="submit"
              :loading="loading"
            >
              Simpan
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="receiveDialog" width="500" persistent>
      <v-form
        :disabled="loading"
        lazy-validation
        ref="receiveForm"
        @submit.prevent="submitReceive"
        style="position: relative"
      >
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Terima Barang
          </v-card-title>

          <v-card-text class="d-flex justify-center align-center">
            <v-col md="12" style="padding: 0; position: relative; top: 20px">
              <v-row no-gutters>
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Keterangan Tambahan
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <div>
                    <v-textarea
                      v-model="uploadDescription"
                      dense
                      :auto-grow="true"
                      outlined
                      rows="1"
                    />
                  </div>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Upload
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <div
                    style="padding: 10px; border: 2px dashed grey; height: 70px"
                  >
                    <v-file-input
                      ref="uploadDoc"
                      placeholder="Pilih File"
                      dense
                      append-icon="mdi-paperclip"
                      prepend-icon=""
                      @change="uploadFileDoc"
                      :rules="rules.docRules"
                    ></v-file-input>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn
              id="closeReceiveDialog"
              color="error"
              text
              outlined
              type="reset"
              @click="closeReceiveDialog"
              :loading="loading"
            >
              Batal
            </v-btn>
            <v-spacer />
            <v-btn
              color="primary"
              text
              outlined
              type="submit"
              :loading="loading"
            >
              Simpan
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-if="result != null" v-model="imageGaleryDialog" width="700">
      <v-form lazy-validation ref="receiveForm" style="position: relative">
        <v-card>
          <v-card-title
            v-if="selectedItem != null"
            class="text-h5 grey lighten-2 uppercase"
          >
            GALERI FOTO
            <span
              style="
                font-size: 16px;
                margin-left: 5px;
                font-weight: bold;
                text-transform: uppercase;
              "
              >-
              {{
                selectedItem.lot != null
                  ? `${selectedItem.lot.asset.code} | ${selectedItem.lot.asset.name} | ${selectedItem.lot.lot_no}`
                  : ''
              }}
            </span>
          </v-card-title>

          <v-card-text>
            <v-row no-gutters v-if="selectedItem != null" class="mt-2">
              <v-col
                v-for="(item, index) in selectedItem.file"
                :key="index"
                class="d-flex child-flex flex-column"
                cols="4"
                style="border: 1px solid #e0e0e0; padding: 5px; cursor: pointer"
              >
                <div style="height: 130px; position: relative">
                  <v-img
                    :src="item.file"
                    :lazy-src="item.file"
                    aspect-ratio="6:9"
                    contain
                    height="125"
                    class="grey lighten-2 position-relative"
                    @click="openImage(item)"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                  <span
                    style="
                      font-size: 10px;
                      position: absolute;
                      top: -5px;
                      left: 5px;
                      z-index: 9;
                      font-weight: bold;
                    "
                  >
                    {{ item.created_by_name }}
                  </span>
                </div>
                <span style="font-size: 10px; width: 210px; line-height: 1">
                  {{ item.description }}
                </span>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn
              color="error"
              text
              outlined
              type="button"
              @click="closeImageGaleryDialog"
            >
              Tutup
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog
      v-if="result != null"
      v-model="itemEditDialog"
      width="700"
      persistent
    >
      <v-form
        :disabled="loading"
        lazy-validation
        ref="itemEditForm"
        @submit.prevent="submitItemEditForm"
        style="position: relative"
      >
        <v-card v-if="selectedItem != null">
          <v-card-title class="text-h5 grey lighten-2">
            Detail Item
          </v-card-title>

          <v-card-text class="d-flex justify-center align-center">
            <v-col cols="12" style="padding: 0; position: relative; top: 20px">
              <v-row no-gutters>
                <v-col cols="12" md="6" style="padding: 0 4px">
                  <v-text-field
                    :value="selectedItem.lot.asset.code"
                    dense
                    outlined
                    disabled
                    label="Kode Asset"
                    style="margin: 0"
                  />
                </v-col>
                <v-col cols="12" md="6" style="padding: 0 4px">
                  <v-text-field
                    :value="selectedItem.lot_no"
                    dense
                    outlined
                    disabled
                    label="No. Lot"
                    style="margin: 0"
                  />
                </v-col>
                <v-col cols="12" style="padding: 0 4px">
                  <v-text-field
                    :value="selectedItem.lot.asset.name"
                    dense
                    outlined
                    disabled
                    label="Nama Asset"
                    style="margin: 0"
                  />
                </v-col>
                <v-col cols="12" md="6" style="padding: 0 4px">
                  <v-text-field
                    :value="selectedItem.lot.company_name"
                    dense
                    outlined
                    disabled
                    label="Kepemilikan"
                    style="margin: 0"
                  />
                </v-col>
                <v-col cols="12" md="6" style="padding: 0 4px">
                  <v-text-field
                    :value="
                      selectedItem.lot.current_company_name +
                      '-' +
                      selectedItem.lot.current_location_name
                    "
                    dense
                    outlined
                    disabled
                    label="Lokasi Asal"
                    style="margin: 0"
                  />
                </v-col>
                <v-col cols="12" md="4" style="padding: 0 4px">
                  <v-text-field
                    :value="selectedItem.lot.qty"
                    dense
                    outlined
                    disabled
                    label="Tersedia"
                    style="margin: 0"
                  />
                </v-col>
                <v-col cols="12" md="4" style="padding: 0 4px">
                  <v-text-field
                    v-model="selectedItem.qty"
                    dense
                    outlined
                    :disabled="result.status != 0"
                    label="Transfer"
                    type="number"
                    min="0"
                    style="margin: 0"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn
              id="closeItemEditDialog"
              color="error"
              text
              outlined
              type="reset"
              @click="closeItemEditDialog"
              :loading="loading"
            >
              Batal
            </v-btn>
            <v-spacer />
            <v-btn
              color="primary"
              text
              outlined
              type="submit"
              :loading="loading"
            >
              Simpan
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import axios from 'axios'
import { mapActions, mapGetters } from 'vuex'
import buildType from '../../../../services/buildType'
import { globalMixin } from '../../../../mixin/globalMixin'
import moment from 'moment-timezone'
export default {
  name: 'Movement-Detail',
  components: {
    Scanner: () => import('../../../home/components/Scanner.vue'),
    LotMovingProcess: () => import('../../movement/components/ProcessLot.vue'),
    AddItem: () => import('./AddItem')
  },
  mixins: [globalMixin],
  data() {
    return {
      uploadApi: buildType.apiURL('upload2'),
      oAuth: buildType.apiURL('oauth'),
      asset: buildType.apiURL('asset'),
      panel: [0, 1],
      dialog: false,
      dialog2: false,
      form: {},
      loading: false,
      result: null,
      reason: '',
      isEdit: false,
      isAllow: false,
      matrix: [],
      wWidth: window.innerWidth,
      lot_item: null,
      movementId: null,
      file_subject: null,
      fileNameUpload: '',
      uploadDescription: null,
      uploadType: null,
      dokumenDialog: false,
      fileUploadDialog: false,
      imageGaleryDialog: false,
      itemEditDialog: false,
      rules: {
        docRules: [],
        subjectRules: [],
        driverRules: [],
        licenseRules: [],
        outDateRules: [],
        photoRules: []
      },
      selectedItem: null,
      verifyOutDialog: false,
      verifyForm: null,
      receiveDialog: false,
      dropdownUploadType: ['receive', 'verify_out', 'condition', 'other']
    }
  },
  mounted() {
    this.getDetailData()
    window.scrollTo(0, 0)
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  computed: {
    ...mapGetters([
      'getUserProfile',
      'getDropdownLocation',
      'getDropdownCompany'
    ]),

    headers() {
      const xArrHeader = []
      // if (this.result.status == 0) {
      xArrHeader.push({
        text: 'Aksi',
        value: 'action',
        align: 'left',
        sortable: false
      })
      // }
      // if (this.result.status != 0) {
      //   xArrHeader.push({
      //     text: 'photo',
      //     value: 'file',
      //     align: 'left',
      //     sortable: false
      //   })
      // }
      xArrHeader.push(
        {
          text: 'Nama Aset',
          value: 'name',
          align: 'left',
          sortable: false
        },
        { text: 'No. Lot', value: 'lot_no', align: 'left', sortable: false },
        {
          text: 'Kepemilikan',
          value: 'company_name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Lokasi asal',
          value: 'current_location_name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Tersedia',
          value: 'qty_available',
          align: 'left',
          sortable: false
        },
        {
          text: 'Transfer',
          value: 'qty_move',
          align: 'left',
          sortable: false
        },
        {
          text: 'Lokasi tujuan',
          value: 'placed_location_name',
          align: 'left',
          sortable: false
        }
        // {
        //   text: 'Catatan',
        //   value: 'note',
        //   align: 'left',
        //   sortable: false
        // }
      )
      if (this.result.status == 2) {
        xArrHeader.push({
          text: 'Diproses',
          value: 'confirm',
          align: 'left',
          sortable: false
        })
      }
      xArrHeader.push({
        text: 'status',
        value: 'status',
        align: 'left',
        sortable: false
      })
      return xArrHeader
    },
    documentHeaders() {
      return [
        {
          text: 'File Name',
          value: 'subject',
          align: 'left',
          sortable: false,
          width: '30%'
        },
        {
          text: 'Tipe',
          value: 'type',
          align: 'left',
          sortable: false,
          width: '15%'
        },
        {
          text: 'Keterangan',
          value: 'description',
          align: 'left',
          sortable: false,
          width: '45%'
        },
        {
          text: 'Action',
          value: 'action',
          align: 'center',
          sortable: false,
          width: '10%'
        }
      ]
    },
    approvalHeaders() {
      const xArrHeader = [
        { text: 'Sequence', value: 'sequence', align: 'left' },
        { text: 'Doc. No', value: 'document_no', align: 'left' },
        { text: 'Model', value: 'table_name', align: 'center' },
        { text: 'User', value: 'approver_user', align: 'center' },
        { text: 'Min. Approver', value: 'min_approver', align: 'center' },
        { text: 'Approved by', value: 'approved', align: 'center' },
        { text: 'Rejected by', value: 'rejected', align: 'center' }
      ]
      return xArrHeader
    }
  },
  methods: {
    ...mapActions([
      'dropdownLocation',
      'documentAuthority',
      'approvalMatrixDocumentList',
      'fetchMatrix',
      'dropdownCompany'
    ]),
    formatDateTime(value) {
      if (!value) return ''

      return moment
        .utc(value, 'DD-MM-YYYY HH:mm:ss')
        .tz('Asia/Jakarta')
        .format('DD-MM-YYYY HH:mm:ss')
    },
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    onResize() {
      this.wWidth = window.innerWidth
    },
    closeReceiveDialog() {
      this.receiveDialog = false
      setTimeout(() => {
        this.fileNameUpload = ''
      }, 200)
    },
    openReceiveDialog() {
      setTimeout(() => {
        this.receiveDialog = true
      }, 200)
    },
    closeVerifyDialog() {
      this.verifyOutDialog = false
      setTimeout(() => {
        this.verifyForm = null
      }, 200)
    },
    openVerifyDialog() {
      const xDateTime = moment(new Date()).format('yyyy-MM-DD HH:mm')
      this.verifyForm = {
        license_plate: null,
        driver_name: null,
        out_date_time: xDateTime
      }
      setTimeout(() => {
        this.verifyOutDialog = true
      }, 200)
    },
    async submitVerifyOut() {
      this.rules.driverRules = [(v) => !!v || 'Nama driver wajib diisi']
      this.rules.licenseRules = [
        (v) => !!v || 'Plat nomor kendaraan wajib diisi'
      ]
      this.rules.outDateRules = [(v) => !!v || 'Tanggal keluar wajib diisi']
      this.rules.photoRules = [(v) => !!v || 'Wajib upload photo']
      if (!this.fileNameUpload) {
        return this.showMsgDialog('warning', 'Wajib upload photo', false)
      }

      const self = this
      setTimeout(function () {
        if (self.$refs.verifyOutForm.validate()) {
          const form = {
            id: self.$route.params.id,
            license_plate: self.verifyForm.license_plate,
            driver_name: self.verifyForm.driver_name,
            out_date_time: self.verifyForm.out_date_time,
            file: self.fileNameUpload,
            description: self.uploadDescription
          }

          self
            .showMsgDialog('question', 'Simpan sekarang ?', true)
            .then(async (res) => {
              if (res.isConfirmed) {
                await axios
                  .post(`${self.asset}movement/verify_out`, form)
                  .then((res) => {
                    if (res.data.status_code === '00') {
                      self.showMsgDialog(
                        'success',
                        'File berhasil disimpan',
                        false
                      )
                      self.closeVerifyDialog()
                      self.getDetailData()
                    } else {
                      self.showMsgDialog('warning', res.data.status_msg, false)
                    }
                  })
                  .catch((err) => {
                    self.showMsgDialog('error', err.message, false)
                  })
              }
            })
        }
      })
    },
    async submitItemEditForm() {
      // this.rules.qty = [(v) => !!v || 'Jumlah transfer wajib diisi']
      const self = this
      setTimeout(function () {
        if (self.$refs.itemEditForm.validate()) {
          const form = {
            act: 'update',
            id: self.selectedItem.id,
            qty: self.selectedItem.qty
          }

          self
            .showMsgDialog('question', 'Simpan sekarang ?', true)
            .then(async (res) => {
              if (res.isConfirmed) {
                await axios
                  .post(`${self.asset}movement/detail/save`, form)
                  .then((res) => {
                    if (res.data.status_code === '00') {
                      self.showMsgDialog(
                        'success',
                        'File berhasil disimpan',
                        false
                      )
                      self.closeItemEditDialog()
                      self.getDetailData()
                    } else {
                      self.showMsgDialog('warning', res.data.status_msg, false)
                    }
                  })
                  .catch((err) => {
                    self.showMsgDialog('error', err.message, false)
                  })
              }
            })
        }
      })
    },
    generatePdfDokumen() {
      // this.printDokumen()
      this.generatePDF(
        // `${this.asset}movement/export_to_pdf/${this.$route.params.id}`,
        `${this.asset}movement/generate_pdf/${this.$route.params.id}`,
        axios
      )
    },
    generateBADokumen() {
      // this.printDokumen()
      this.generatePDF(
        // `${this.asset}movement/export_to_pdf/${this.$route.params.id}`,
        `${this.asset}movement/generate_ba/${this.$route.params.id}`,
        axios
      )
    },
    downloadDokumen() {
      setTimeout(() => {
        this.dokumenDialog = true
      }, 300)
    },
    readyToDownload(fileLink) {
      window.open(fileLink.file, '_blank')
    },
    unlinkDokumen(fName, pValue) {
      this.loading = true
      const data = {
        module: 'movement',
        file_name: fName
      }
      axios
        .post(`${this.uploadApi}esanqua/ams/unlink`, data)
        .then((res) => {
          if (res.data.status_code === '00') {
            this.fileNameUpload = ''
            if (pValue === undefined) {
              if (this.selectedItem == null) {
                this.removeFileFromDetail(fName)
              }
            }
          } else {
            this.showMsgDialog('warning', res.data.status_msg, false)
            if (pValue === undefined) {
              if (res.data.status_msg === 'File not found') {
                if (this.selectedItem == null) {
                  this.removeFileFromDetail(fName)
                }
              }
            }
          }
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          this.showMsgDialog('error', err.message, false)
        })
    },
    removeFileFromDetail(fName) {
      for (let i = 0; i < this.result.file.length; i++) {
        if (this.result.file[i].file.includes(fName)) {
          this.result.file.splice(i, 1)
        }
      }
      this.updatePhoto(false)
    },
    async deleteAllFile() {
      this.showMsgDialog(
        'question',
        'Semua file akan terhapus, Anda yakin ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          const form = {
            id: this.$route.params.id,
            file: []
          }
          await axios
            .post(`${this.asset}movement/update_file_upload`, form)
            .then((res) => {
              if (res.data.status_code === '00') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDetailData()
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
              this.loading = false
              setTimeout(() => {
                this.dokumenDialog = false
              }, 300)
            })
            .catch((err) => {
              this.loading = false
              this.showMsgDialog('error', err.message, false)
            })
        }
      })
    },
    closeDokumenDialog() {
      setTimeout(() => {
        this.dokumenDialog = false
      }, 300)
    },
    uploadPhotoPerItem(item, index) {
      this.selectedItem = item
      this.file_subject =
        item.lot != null
          ? `(${item.lot.asset.code}) ${item.lot.asset.name}`
          : ''
      this.uploadDoc('upload')
    },
    uploadDoc(event) {
      if (event === 'upload') {
        setTimeout(() => {
          this.fileUploadDialog = true
        }, 500)
      }
      if (event === 'close') {
        if (this.fileNameUpload !== '') {
          let fName = ''
          fName = this.fileNameUpload
          this.unlinkDokumen(fName, true)
          this.file_subject = null
          this.uploadDescription = null
          this.uploadType = null
          this.selectedItem = null
          // this.$refs.uploadDoc.reset()
        }
        this.$refs.entryFormUpload.reset()
        setTimeout(() => {
          this.fileUploadDialog = false
        }, 500)
      }
      this.fileNameUpload = ''
    },
    uploadFileDoc(event) {
      if (event !== null) {
        if (event.size <= 1024 * 1024 * 2) {
          this.loading = true
          const data = new FormData()
          data.append('file', event)
          data.append('module', 'movement')
          axios
            .post(`${this.uploadApi}esanqua/ams`, data)
            .then((res) => {
              if (res.data.status === true) {
                this.showMsgDialog(
                  'success',
                  'File siap disimpan, Silahkan lanjutkan dengan klik tombol "simpan file"',
                  false
                )
                this.fileNameUpload = res.data.data.name
                console.log(this.fileNameUpload, this.selectedItem)

                if (this.selectedItem != null) {
                  this.updatePhotoItemV2(true)
                }
                // setTimeout(() => {
                //   this.submitUploadDoc()
                // }, 200)
              } else {
                this.showMsgDialog('warning', res.data.message, false)
              }
              this.loading = false
            })
            .catch((err) => {
              this.loading = false
              this.showMsgDialog('error', err.message, false)
            })
        } else {
          setTimeout(() => {
            this.showMsgDialog('warning', 'Max size = 2MB', false)
            this.fileNameUpload = ''
          }, 300)
        }
      } else {
        this.fileNameUpload = ''
        // this.$refs.uploadDoc.reset()
      }
    },
    submitUploadDoc() {
      this.rules.docRules = [(v) => !!v || 'Tidak ada file yang terupload']
      this.rules.subjectRules = [(v) => !!v || 'Kolom Subject diperlukan']
      const self = this
      setTimeout(function () {
        if (self.$refs.entryFormUpload.validate()) {
          self.updatePhoto(true)
        }
      })
    },
    async updatePhoto(isAddFile) {
      const file = []
      if (this.result.file != null) {
        for (let i = 0; i < this.result.file.length; i++) {
          const fName = this.result.file[i].file.slice(
            this.result.file[i].file.lastIndexOf('/') + 1
          )
          file.push({
            subject: this.result.file[i].subject,
            file: fName,
            created_by: this.result.file[i].created_by,
            created_by_name: this.result.file[i].created_by_name,
            description: this.result.file[i].description || null,
            type: this.result.file[i].type || null,
            item_id: this.result.file[i].item_id || null
          })
        }
      }
      if (isAddFile) {
        file.push({
          subject: this.file_subject,
          file: this.fileNameUpload,
          created_by: this.getUserProfile.employee.id,
          created_by_name: this.getUserProfile.employee.name,
          description: this.uploadDescription,
          type: this.uploadType || 'other',
          item_id: null
        })
      }
      const form = {
        id: this.$route.params.id,
        file: file
      }
      console.log('Upload Lampiran:', form)
      await axios
        .post(`${this.asset}movement/update_file_upload`, form)
        .then((res) => {
          if (res.data.status_code === '00') {
            this.showMsgDialog('success', 'File berhasil disimpan', false)
            this.file_subject = null
            this.fileNameUpload = ''
            this.uploadDescription = null
            this.uploadType = null
            this.selectedItem = null
            document.getElementById('closeFileUpload').click()
            this.getDetailData()
          } else {
            this.showMsgDialog('error', res.data.status_msg, false)
            this.unlinkDokumen(this.fileNameUpload)
          }
        })
        .catch((err) => {
          this.showMsgDialog('error', err.message, false)
          this.fileNameUpload = ''
          this.uploadDescription = null
          this.uploadType = null
          this.selectedItem = null
          if (this.$refs.entryFormUpload) {
            this.$refs.entryFormUpload.reset()
          }
        })
      this.isEdit = false
    },
    async updatePhotoItem(isAddFile) {
      const form = {
        id: this.selectedItem.id,
        file: this.fileNameUpload
      }
      await axios
        .post(`${this.asset}movement/detail/save_photo`, form)
        .then((res) => {
          if (res.data.status_code === '00') {
            this.showMsgDialog('success', 'File berhasil disimpan', false)
            this.file_subject = null
            this.fileNameUpload = ''
            this.selectedItem = null
            this.uploadDescription = null
            this.uploadType = null
            document.getElementById('closeFileUpload').click()
            this.getDetailData()
          } else {
            this.showMsgDialog('error', res.data.status_msg, false)
            this.unlinkDokumen(this.fileNameUpload)
          }
        })
        .catch((err) => {
          this.showMsgDialog('error', err.message, false)
          this.fileNameUpload = ''
          this.uploadDescription = null
          this.uploadType = null
          this.selectedItem = null
          if (this.$refs.entryFormUpload) {
            this.$refs.entryFormUpload.reset()
          }
        })
      this.isEdit = false
    },
    async updatePhotoItemV2(isAddFile) {
      const file = []
      if (this.result.file != null) {
        for (let i = 0; i < this.result.file.length; i++) {
          const fName = this.result.file[i].file.slice(
            this.result.file[i].file.lastIndexOf('/') + 1
          )
          file.push({
            subject: this.result.file[i].subject,
            file: fName,
            created_by: this.result.file[i].created_by || null,
            created_by_name: this.result.file[i].created_by_name || null,
            description: this.result.file[i].description || null,
            type: this.result.file[i].type || null,
            item_id: this.result.file[i].item_id || null
          })
        }
      }
      if (isAddFile) {
        file.push({
          subject: this.file_subject,
          file: this.fileNameUpload,
          created_by: this.getUserProfile.employee.id,
          created_by_name: this.getUserProfile.employee.name,
          item_id: this.selectedItem.id,
          description: this.uploadDescription,
          type: 'condition'
        })
      }
      const form = {
        id: this.$route.params.id,
        file: file
      }
      console.log('Upload foto per Item:', form)
      await axios
        .post(`${this.asset}movement/update_file_upload`, form)
        .then((res) => {
          if (res.data.status_code === '00') {
            this.showMsgDialog('success', 'File berhasil disimpan', false)
            this.file_subject = null
            this.fileNameUpload = ''
            this.selectedItem = null
            this.uploadDescription = null
            this.uploadType = null
            document.getElementById('closeFileUpload').click()
            this.getDetailData()
          } else {
            this.showMsgDialog('error', res.data.status_msg, false)
            this.unlinkDokumen(this.fileNameUpload)
          }
        })
        .catch((err) => {
          this.showMsgDialog('error', err.message, false)
          this.fileNameUpload = ''
          this.uploadDescription = null
          this.uploadType = null
          if (this.$refs.entryFormUpload) {
            this.$refs.entryFormUpload.reset()
          }
        })
      this.isEdit = false
    },
    addItem() {
      setTimeout(() => {
        document.getElementById('addItemMovement').click()
      }, 500)
    },
    initLot(pItem) {
      const xPayloadAddItems = []
      for (let i = 0; i < pItem.length; i++) {
        console.log(pItem[i])
        const a = {
          company_id: pItem[i].company_id,
          company_name: pItem[i].company_name,
          current_location_name: pItem[i].current_location_name,
          current_company_name: pItem[i].current_company_name,
          lot_id: Number(pItem[i].id),
          lot_no: pItem[i].name,
          name: pItem[i].asset_name,
          qty: parseFloat(pItem[i].qty_move), // qty_move is used to store the qty that will be moved, while qty is used to store the available qty in the current location
          qty_available: parseFloat(pItem[i].qty), // qty is used to store the available qty in the current location
          // qty_move: parseFloat(pItem[i].qty_move),
          // qty: parseFloat(pItem[i].qty)
          note: pItem[i].note
        }
        xPayloadAddItems.push(a)
      }
      this.createFormAddItem(xPayloadAddItems)
    },
    createFormAddItem(xItems) {
      const newForm = {
        move_id: this.result.id,
        item: xItems
      }
      console.log('newForm>>>', newForm)
      this.saveItem(newForm)
    },
    saveItem(form) {
      this.loading = true
      axios
        .post(`${this.asset}movement/detail/save_batch`, form)
        .then((res) => {
          this.loading = false
          if (res.data.status_code == '00') {
            this.showMsgDialog('success', res.data.status_msg, false)
            this.getDetailData()
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              let xFlag = false
              if (res.data.error_msg !== undefined) {
                if (res.data.error_msg !== null) {
                  if (res.data.error_msg.length > 0) {
                    this.showMsgDialog(
                      'error',
                      `${res.data.error_msg[0].msg} (${res.data.error_msg[0].value})`,
                      false
                    )
                  } else {
                    xFlag = true
                  }
                } else {
                  xFlag = true
                }
              } else {
                xFlag = true
              }

              if (xFlag) {
                this.showMsgDialog(
                  'error',
                  'Invalid input, Parameter value has problem',
                  false
                )
              }
            } else {
              this.showMsgDialog('error', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          this.loading = false
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    deleteItem(pItem, index) {
      this.showMsgDialog(
        'question',
        'Lot ini akan dihapus, Anda yakin ?',
        true
      ).then((res) => {
        if (res.isConfirmed) {
          axios
            .delete(`${this.asset}movement/detail/delete/${pItem.id}`)
            .then((res) => {
              console.log('delete>>>>', res)
              if (res.data.status_code == '00') {
                this.showMsgDialog('success', res.data.status_msg, false)
                setTimeout(() => {
                  this.isEdit = false
                  this.getDetailData()
                }, 200)
              } else {
                this.showMsgDialog('error', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              this.showMsgDialog('error', err.message, false)
            })
        }
      })
    },
    async deleteAllItem() {
      this.showMsgDialog(
        'question',
        'Item tersebut akan dihapus, Anda yakin ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          for (let i = 0; i < this.result.item.length; i++) {
            await axios
              .delete(
                `${this.asset}movement/detail/delete/${this.result.item[i].id}`
              )
              .then((res) => {
                console.log('delete>>>>', res)
                if (i == this.result.item.length - 1) {
                  if (res.data.status_code === '00') {
                    this.showMsgDialog('success', res.data.status_msg, false)
                  } else {
                    this.showMsgDialog('error', res.data.status_msg, false)
                  }
                }
                return null
              })
              .catch((err) => {
                if (i == this.result.item.length - 1) {
                  this.showMsgDialog('error', err.message, false)
                }
                return null
              })
          }
          this.getDetailData()
        }
      })
    },
    // printDokumen() {
    //   this.loading = true
    //   axios({
    //     url: `${this.asset}movement/generate_receipt_pdf/${this.result.id}`,
    //     method: 'GET',
    //     responseType: 'blob'
    //   })
    //     .then((res) => {
    //       this.loading = false
    //       const url = window.URL.createObjectURL(new Blob([res.data]))
    //       const link = document.createElement('a')
    //       link.href = url
    //       link.setAttribute('download', `AMS-${this.result.doc_no}.pdf`)
    //       document.body.appendChild(link)
    //       link.click()
    //     })
    //     .catch((error) => {
    //       console.log(error)
    //       this.loading = false
    //       this.showMsgDialog(
    //         'error',
    //         'Printing failed, please contact an Admin',
    //         false
    //       )
    //     })
    // },
    rowClick(pItem) {
      console.log('submitItemEditForm', pItem)
      if (pItem) {
        this.selectedItem = pItem
        setTimeout(() => {
          this.itemEditDialog = true
        }, 200)
      }
    },
    closeItemEditDialog() {
      this.itemEditDialog = false
      setTimeout(() => {
        this.selectedItem = null
      }, 400)
    },
    closeImageGaleryDialog() {
      this.imageGaleryDialog = false
      setTimeout(() => {
        this.selectedItem = null
      }, 200)
    },
    openItemImage(pItem) {
      console.log(pItem)
      if (pItem) {
        this.selectedItem = pItem
        setTimeout(() => {
          this.imageGaleryDialog = true
        }, 200)
      }
    },
    openImage(pItem) {
      console.log(pItem)
      if (pItem.file) {
        window.open(pItem.file, '_blank')
      } else {
        this.showMsgDialog('warning', 'Belum ada foto', false)
      }
      // setTimeout(() => {
      //   this.$router.push(`/hr/leave/detail/${pItem.id}`)
      // }, 100)
    },
    getDetailData() {
      this.loading = true
      console.log('getUserProfile', this.getUserProfile)
      this.result = null
      axios
        .get(`${this.asset}movement/detail/${this.$route.params.id}}`)
        // .get(`${this.asset}movement/detail/${this.moveId.id}}`)
        .then((res) => {
          console.log('Detail', res)
          if (res.data.status_code == '00') {
            this.result = res.data.data
            this.dropdownLocation(res.data.data.destination_company_id)
            // this.dropdownLocation(this.getUserProfile.employee.company.id)
            this.authorityCheck(res.data.data)
            this.matrixCheck(res.data.data)
          }
          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
        })
    },
    // clickOutside() {
    //   this.$emit('close')
    // },
    close() {
      // this.$emit('close')
      // this.dialog = false
      this.$router.push('/asset-management/pemindahan-aset')
    },
    submitReceive() {
      const newArr = []
      if (this.result.item && this.result.item.length > 0) {
        // check if there are some item with qty transfer more than available qty, if there are then reject process
        if (
          this.result.item.find((obj) => obj.qty > obj.lot.qty) != undefined
        ) {
          this.showMsgDialog(
            'warning',
            'Tidak dapat diproses, terdapat barang dengan qty transfer melebihi jumlah stock yang tersedia',
            false
          )
          return
        }
        for (let i = 0; i < this.result.item.length; i++) {
          if (this.result.item[i].lot) {
            const xObj = {
              id: this.result.item[i].id,
              lot_id: this.result.item[i].lot.id,
              lot_no: this.result.item[i].lot.lot_no
            }
            if (this.result.item[i].lot.placed_location) {
              Object.assign(xObj, {
                placed_location_id: this.result.item[i].lot.placed_location.id,
                placed_location_name:
                  this.result.item[i].lot.placed_location.name,
                qty: this.result.item[i].qty,
                current_company_id: this.result.item[i].lot.current_company_id,
                current_company_name:
                  this.result.item[i].lot.current_company_name,
                current_location_id:
                  this.result.item[i].lot.current_location_id,
                current_location_name:
                  this.result.item[i].lot.current_location_name
              })
            }

            if (
              this.result.item[i].lot.status != undefined &&
              this.result.item[i].lot.status != null &&
              this.result.item[i].lot.status == -1
            ) {
              Object.assign(xObj, {
                status: this.result.item[i].lot.status
              })
            }

            newArr.push(xObj)
          }
        }

        if (newArr.length > 0) {
          this.showMsgDialog(
            'question',
            'Proses lokasi penyimpanan sekarang ?',
            true
          ).then((res) => {
            if (res.isConfirmed) {
              this.initProcessPayload(newArr)
            }
          })
        } else {
          this.showMsgDialog(
            'warning',
            'Ada data yang belum terisi dengan benar',
            false
          )
        }
      } else {
        this.showMsgDialog('warning', 'Tidak ada data yang dipindahkan', false)
      }
    },
    initProcessPayload(arr) {
      const newForm = {
        id: this.result.id,
        item: arr,
        file: this.fileNameUpload,
        description: this.uploadDescription
      }
      console.log(newForm)
      // check all item inside arr already have placed_location_id, placed_company_id or not, if one item do not have then reject process
      // if (
      //   newForm.item.find(
      //     (obj) =>
      //       obj.placed_location_id == undefined &&
      //       obj.placed_company_id == undefined
      //   ) != undefined
      // ) {
      //   this.showMsgDialog(
      //     'warning',
      //     'Tidak dapat diproses, pastikan semua barang sudah dipilih lokasi penyimpanannya',
      //     false
      //   )
      //   return
      // }
      // console.log('yoheee')

      this.receiveNow(newForm)
    },
    receiveNow(form) {
      this.loading = true
      axios
        .post(`${this.asset}movement/receive`, form)
        .then((res) => {
          if (res.data.status_code == '00') {
            this.showMsgDialog('success', res.data.status_msg, false)
            this.getDetailData()
            this.closeReceiveDialog()
          } else {
            if (res.data.status_msg == 'Parameter value has problem') {
              this.showMsgDialog(
                'error',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('error', res.data.status_msg, false)
            }
          }
          this.loading = false
        })
        .catch((err) => {
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
          this.loading = false
        })
    },

    approveMovement() {
      const form = {
        document_id: this.result.approval_matrix[0].document_id,
        status: 1
      }
      this.confirmNow(form)
    },
    rejectMovement() {
      const form = {
        document_id: this.result.approval_matrix[0].document_id,
        status: -1
      }
      this.confirmNow(form)
    },
    confirmNow(form) {
      this.loading = true
      axios
        .post(`${this.asset}movement/confirm`, form)
        .then((res) => {
          if (res.data.status_code == '00') {
            if (form.status == -1) {
              this.showMsgDialog(
                'success',
                'Data has been successfully rejected',
                false
              )
            } else {
              this.showMsgDialog('success', res.data.status_msg, false)
            }
            this.getDetailData()
          } else {
            if (res.data.status_msg == 'Parameter value has problem') {
              this.showMsgDialog(
                'error',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('error', res.data.status_msg, false)
            }
          }
          this.loading = false
        })
        .catch((err) => {
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
          this.loading = false
        })
    },
    authorityCheck(item) {
      const matrixId = item.approval_matrix[0].document_id
      axios
        .get(
          `${this.oAuth}approval_matrix/document/allow_user?document_id=${matrixId}&application_id=18&table_name=${item.approval_matrix[0].table_name}`
        )
        .then((res) => {
          console.log('authorityCheck', res)
          if (res.data.status_code == '00') {
            if (res.data.is_allow_approve !== 0) {
              this.isAllow = true
            } else {
              this.isAllow = false
            }
          } else {
            this.isAllow = false
          }
        })
        .catch((err) => {
          this.showMsgDialog(
            'error',
            err
              ? 'Authority check error, please contact an Admin'
              : 'Authority check error, please contact an Admin',
            false
          )
        })
    },
    matrixCheck(item) {
      axios
        .get(
          `${this.oAuth}approval_matrix/document/list?limit=100&offset=0&keyword=&application_id=18&table_name=${item.approval_matrix[0].table_name}&document_id=${item.approval_matrix[0].document_id}`
        )
        .then((res) => {
          if (res.data.status_code == '00') {
            this.matrix = res.data.data
          } else {
            this.showMsgDialog('error', res.data.status_msg, false)
          }
        })
        .catch((err) => {
          this.showMsgDialog(
            'error',
            err
              ? 'Authority check error, please contact an Admin'
              : 'Authority check error, please contact an Admin',
            false
          )
        })
    },
    fetchApproval() {
      this.matrix = []
      const form = {
        act: 'fetch_matrix',
        document_id: this.$route.params.id,
        document_no: this.result.doc_no,
        application_id: 18,
        table_name: 'ams_tr_assetmovements',
        company_id: this.result.source_company_id
      }
      this.loading = true
      axios
        .post(`${this.oAuth}approval_matrix/document/save`, form)
        .then((res) => {
          // console.log('>>> fetch:', res.data.status_code)
          if (res.data.status_code == '00') {
            this.showMsgDialog('success', 'Fetch matrix success', false)
            this.getDetailData()
          } else {
            if (res.data.status_msg == 'Parameter value has problem') {
              this.showMsgDialog('error', res.error_msg[0].msg, false)
            } else {
              this.showMsgDialog('error', res.status_msg, false)
            }
          }
          this.loading = false
        })
        .catch((err) => {
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, please contact an Admin'
              : 'Something went wrong, please contact an Admin',
            false
          )
          this.loading = false
        })
    },
    cancelRequest() {
      this.showMsgDialog('question', 'Batalkan sekarang', true).then((res) => {
        if (res.isConfirmed) {
          const xArrItem = this.result.item || []
          const xCheckProcessedItem = xArrItem.find(({ status }) => status == 1)
          if (
            xCheckProcessedItem != undefined &&
            this.getUserProfile.level.find(({ id }) => id == 1) == undefined
          ) {
            this.showMsgDialog(
              'warning',
              'Tidak dapat dibatalkan, sudah ada item yang diproses',
              false
            )
            return
          }
          const form = {
            id: this.result.id,
            confirm_note: this.reason
          }
          this.loading = true
          axios
            .post(`${this.asset}movement/cancel`, form)
            .then((res) => {
              if (res.data.status_code == '00') {
                this.reason = ''
                this.showMsgDialog('success', res.data.status_msg, 'false')
              } else {
                this.showMsgDialog('warning', res.data.status_msg, 'false')
              }
              this.getDetailData()
              this.loading = false
              this.dialog2 = false
            })
            .catch((err) => {
              console.log(err)
              this.loading = false
            })
        }
      })
    },
    cancelEditHeader() {
      this.isEdit = false
      setTimeout(() => {
        delete this.result.destination
        this.getDetailData()
      }, 200)
    },
    editHeader() {
      this.dropdownCompany()
      this.result.destination = {
        id: this.result.destination_company_id,
        name: this.result.destination_company_name
      }
      const months = {
        Jan: '01',
        Feb: '02',
        Mar: '03',
        Apr: '04',
        May: '05',
        Jun: '06',
        Jul: '07',
        Aug: '08',
        Sep: '09',
        Oct: '10',
        Nov: '11',
        Dec: '12'
      }

      const [dayFrom, monthFrom, yearFrom] =
        this.result.schedule_from.split(' ')

      const [dayTo, monthTo, yearTo] = this.result.schedule_to.split(' ')

      this.result.schedule_from = `${yearFrom}-${
        months[monthFrom]
      }-${dayFrom.padStart(2, '0')}`

      this.result.schedule_to = `${yearTo}-${months[monthTo]}-${dayTo.padStart(
        2,
        '0'
      )}`
      setTimeout(() => {
        this.isEdit = true
      }, 200)
    },
    saveEditHeader() {
      this.showMsgDialog(
        'question',
        'Anda yakin ingin menyimpan data ini ?',
        true
      ).then((res) => {
        if (res.isConfirmed) {
          const form = {
            act: 'update',
            id: this.result.id,
            schedule_from: this.result.schedule_from,
            schedule_to: this.result.schedule_to,
            destination_company_id: this.result.destination.id,
            destination_company_name: this.result.destination.name,
            description: this.result.description,
            driver_name: this.result.driver_name,
            license_plate: this.result.license_plate
          }
          this.loading = true
          axios
            .post(`${this.asset}movement/save`, form)
            .then((res) => {
              this.isEdit = false
              if (res.data.status_code == '00') {
                this.showMsgDialog('success', res.data.status_msg, 'false')
              } else {
                this.showMsgDialog('warning', res.data.status_msg, 'false')
              }
              this.getDetailData()
              this.loading = false
            })
            .catch((err) => {
              console.log(err)
              this.isEdit = false
              this.loading = false
            })
        }
      })
    },
    submitMovement() {
      this.showMsgDialog(
        'question',
        'Anda yakin ingin submit dokumen pemindahan sekarang?',
        true
      ).then((res) => {
        if (res.isConfirmed) {
          const form = {
            id: this.result.id
          }
          this.loading = true
          axios
            .post(`${this.asset}movement/submit`, form)
            .then((res) => {
              if (res.data.status_code == '00') {
                this.showMsgDialog('success', res.data.status_msg, 'false')
              } else {
                this.showMsgDialog('warning', res.data.status_msg, 'false')
              }
              this.getDetailData()
              this.loading = false
            })
            .catch((err) => {
              console.log(err)
              this.loading = false
            })
        }
      })
    },
    setDraft() {
      this.showMsgDialog('question', 'Kembalikan menjadi draft ?', true).then(
        (res) => {
          if (res.isConfirmed) {
            const form = {
              id: this.result.id
            }
            this.loading = true
            axios
              .post(`${this.asset}movement/set_to_draft`, form)
              .then((res) => {
                if (res.data.status_code == '00') {
                  this.reason = ''
                  this.showMsgDialog('success', res.data.status_msg, 'false')
                } else {
                  this.showMsgDialog('warning', res.data.status_msg, 'false')
                }
                this.getDetailData()
                this.loading = false
              })
              .catch((err) => {
                console.log(err)
                this.loading = false
              })
          }
        }
      )
    },
    convertDate(val) {
      const raw = val
      if (raw !== null) {
        const date = new Date(raw)
        const local = date.toLocaleString('id')
        return local
      }
    },
    headTable(v) {
      switch (v) {
        case 1:
          return this.headers
        case 2:
          if (
            this.getUserProfile.employee.company.plant_id ==
            this.result.destination_company_id
          ) {
            return this.headers2
          }
          return this.headers3
        default:
          return this.headers
      }
    },
    itemStatus(v) {
      switch (v) {
        case -1:
          return 'Unreceived'
        case 0:
          return 'Pending'

        case 1:
          return 'Received'
        default:
          return 'null'
      }
    },
    color(v) {
      switch (v) {
        case -1:
          return 'red'

        case 0:
          return 'grey'

        case 1:
          return 'green'

        default:
          return 'black'
      }
    },
    color2(v) {
      switch (v) {
        case -1:
          return 'hsla(10, 90%, 60%, 0.3)'

        case 1:
          return 'hsla(100, 50%, 50%, 0.3)'

        default:
          return 'white'
      }
    },
    statusColor(val) {
      let color = null
      if (val < 0) {
        color = 'red'
      } else {
        const arrType = ['grey', 'orange', 'green', 'green']
        color = arrType[val]
      }
      return color
    },
    movementStatus(v) {
      switch (v) {
        case -2:
          return 'Canceled'
        case -1:
          return 'Rejected'
        case 0:
          return 'Draft'
        case 1:
          return 'Waiting Approval'
        case 2:
          return 'Confirmed'
        case 3:
          return 'Received'
        default:
          return '-'
      }
    },
    lotProcess(v) {
      if (this.result.item.find(({ lot }) => lot.lot_no == v) != undefined) {
        this.lot_item = this.result.item.find(({ lot }) => lot.lot_no == v)
        this.movementId = this.result.id
        setTimeout(() => {
          document.getElementById('processLot').click()
        }, 500)
      } else {
        setTimeout(() => {
          this.showMsgDialog('info', 'Lot tidak terdaftar di form ini', false)
        }, 500)
      }
    }
  }
}
</script>
<style lang="sass" scoped>
.v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap
  padding: 10px

.v-expansion-panel
  border-top: 1px solid #ddd
</style>
